module.exports = __webpack_public_path__ + "img/biceps.f4dc7df7.svg";